goog.provide("shadow.js.shim.module$$microsoft$fetch_event_source");
goog.provide("module$shadow_js_shim_module$$microsoft$fetch_event_source");
shadow.js.shim.module$$microsoft$fetch_event_source = shadow.js.nativeProvides["@microsoft/fetch-event-source"] = shadow$bridge("@microsoft/fetch-event-source");
module$shadow_js_shim_module$$microsoft$fetch_event_source.default = shadow.js.shim.module$$microsoft$fetch_event_source;
